"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.azPetVetPalette = void 0;
var palette_1 = require("../../shared/palette");
var palette = {
    primary: {
        '100': '#D2E0F9',
        '300': '#184FB4',
        '500': '#0D2A5E',
        '700': '#091C3F',
        '900': '#040E1F',
    },
    secondary: {
        '100': '#FBEBE9',
        '300': '#F3C5BE',
        '500': '#AA311E',
        '700': '#882718',
        '900': '#661D12',
    },
    tertiary: {
        '100': '#FBEBE9',
        '300': '#F3C5BE',
        '500': '#AA311E',
        '700': '#882718',
        '900': '#661D12',
    },
    neutrals: __assign(__assign({}, palette_1.commonNeutrals), { '100': '#EFEFEF', '300': '#DADADA', '500': '#B0B0B0', '700': '#4F4F4F', '900': '#363636' }),
    text: __assign(__assign({}, palette_1.commonTextColors), { disabled: '#A7ADB0', tertiary: '#696E72', secondary: '#0C0C0C', primary: '#0D2A5E', interactive: '#184FB4' }),
    accent01: {
        '100': '#EFF7FC',
        '300': '#D0E8F7',
        '500': '#61B3E4',
        '700': '#4E8FB6',
        '900': '#3A6B89',
    },
    accent02: {
        '100': '#E9F5FB',
        '300': '#BAD8EA',
        '500': '#61B3E4',
        '700': '#2598DA',
        '900': '#165B83',
    },
    accent03: {
        '100': '#EBF9F0',
        '300': '#D7F4E1',
        '500': '#A2E4B9',
        '700': '#88DDA6',
        '900': '#61D188',
    },
    accent04: {
        '100': '#FCEBE8',
        '300': '#F4B0A4',
        '500': '#EB6851',
        '700': '#B72E15',
        '900': '#892210',
    },
    success: __assign({}, palette_1.commonSuccess),
    error: __assign({}, palette_1.commonError),
    warning: __assign({}, palette_1.commonWarning),
    info: __assign({}, palette_1.commonInfo),
    background: __assign(__assign(__assign({}, palette_1.commonBackgroundColors), palette_1.commonGradients), { neutral: '#F7F7F7', light: '#EFEFEF', lightTwo: '#EB6851', lightThree: '#6DAA63', dark: '#0D2A5E', darkTwo: '#091C3F', neutralGradient: 'linear-gradient(180deg, #F0F0F0 0%, #FAFAFA 70%)', lightGradient: 'linear-gradient(180deg, #E8E8E8 0%, #F5F5F5 100%)', lightTwoGradient: 'linear-gradient(180deg, #E0634D 0%, #F76D55 70%)', lightThreeGradient: 'linear-gradient(180deg, #67A15E 0%, #74B569 70%)', darkGradient: 'linear-gradient(165deg, #0C2654 4.91%, #0E2F69 89.46%)', ODPHeroGradient: 'linear-gradient(97deg, rgba(13, 42, 94, 0.85) 33.86%, rgba(13, 42, 94, 0.00) 73.68%)', teamTagBrandColor: '#39863C' }),
};
exports.azPetVetPalette = {
    primary: {
        lightest: palette.primary[100],
        light: palette.primary[300],
        main: palette.primary[500],
        dark: palette.primary[700],
        darkest: palette.primary[900],
    },
    secondary: {
        lightest: palette.secondary[100],
        light: palette.secondary[300],
        main: palette.secondary[500],
        dark: palette.secondary[700],
        darkest: palette.secondary[900],
    },
    tertiary: {
        lightest: palette.tertiary[100],
        light: palette.tertiary[300],
        main: palette.tertiary[500],
        dark: palette.tertiary[700],
        darkest: palette.tertiary[900],
    },
    neutrals: {
        white: palette.neutrals.white,
        neutral: palette.neutrals[100],
        primary: palette.neutrals[300],
        disabled: palette.neutrals[500],
        secondary: palette.neutrals[900],
        tertiary: palette.neutrals[700],
    },
    text: {
        primary: palette.text.primary,
        secondary: palette.text.secondary,
        tertiary: palette.text.tertiary,
        light: palette.text.light,
        disabled: palette.text.disabled,
        interactive: palette.text.interactive,
    },
    accent01: {
        lightest: palette.accent01[100],
        light: palette.accent01[300],
        main: palette.accent01[500],
        dark: palette.accent01[700],
        darkest: palette.accent01[900],
    },
    accent02: {
        lightest: palette.accent02[100],
        light: palette.accent02[300],
        main: palette.accent02[500],
        dark: palette.accent02[700],
        darkest: palette.accent02[900],
    },
    accent03: {
        lightest: palette.accent03[100],
        light: palette.accent03[300],
        main: palette.accent03[500],
        dark: palette.accent03[700],
        darkest: palette.accent03[900],
    },
    accent04: {
        lightest: palette.accent04[100],
        light: palette.accent04[300],
        main: palette.accent04[500],
        dark: palette.accent04[700],
        darkest: palette.accent04[900],
    },
    success: {
        light: palette.success[300],
        main: palette.success[500],
        dark: palette.success[700],
    },
    error: {
        light: palette.error[300],
        main: palette.error[500],
        dark: palette.error[700],
    },
    warning: {
        light: palette.warning[300],
        main: palette.warning[500],
        dark: palette.warning[700],
    },
    info: {
        light: palette.info[300],
        main: palette.info[500],
        dark: palette.info[700],
    },
    backgrounds: __assign({}, palette.background),
};
